/**
 * Status da conta do usuário na plataforma.
 *
 * Quando um admin inativa alguém (Config → Usuários), duas coisas acontecem:
 *   1. `profiles.status` vira 'inactive';
 *   2. a edge function `manage-users` bane a conta no Auth (`ban_duration`),
 *      então o GoTrue passa a recusar o login com o erro `user_banned`.
 *
 * Em nenhum dos dois casos o usuário vê "conta desativada/bloqueada": a
 * plataforma responde como se estivesse em manutenção programada
 * (ver `src/components/MaintenanceScreen.tsx`).
 */

/** Erro de login de conta banida no Auth (usuário inativado no VigorHub). */
export const isContaSuspensa = (error: unknown): boolean => {
    if (!error || typeof error !== 'object') return false;
    const err = error as { code?: string; error_code?: string; message?: string };
    if (err.code === 'user_banned' || err.error_code === 'user_banned') return true;
    return /user\s+is\s+banned/i.test(err.message ?? '');
};

/** Perfil inativado — vale para sessão já aberta (o ban só corta no refresh do token). */
export const isPerfilInativo = (status?: string | null): boolean => status === 'inactive';
